<template>
    <div class="lunch-list">
        <div
            v-for="(item, key) in lunchList"
            :key="`item-${key}`"
            class="lunch-list-item"
            :class="{
                ['today']: item.activeLunch,
            }"
        >
            <h3 class="h4">{{ `${$t(item.date.toFormat('cccc'))} ${item.date.toFormat('d.M.')}` }}</h3>
            <div
                v-for="(menuItem, mKey) in item.items.products"
                :key="`menu-item-${mKey}`"
                class="item"
            >
                <span>
                    {{ menuItem.name }}<!--
                    --><br v-if="!bps.isSmallDesktop">
                    <span v-else-if="menuItem.specialties">, </span>
                    {{ menuItem.specialties ? menuItem.specialties.join(', ') : '' }}
                </span>
                <strong>{{ $cms.formatPrice(menuItem.price) }}</strong>
            </div>
            <DSCFText
                v-if="item.items.placeholderText"
                :content="item.items.placeholderText"
            />
        </div>
    </div>
</template>
<script>
import { DateTime } from 'luxon';
import { mapState } from 'pinia';
import { usePageStore } from '~dsc/stores/cms/page';

export default {
    name: 'StationsFunctionsLunchList',
    computed: {
        ...mapState(usePageStore, ['station']),
        lunchList() {
            const date = DateTime.now().startOf('week');
            const { lunch = {} } = this.station;
            const { currentLunchTimeStamp = DateTime.now().toMillis() } = lunch;
            const currentLunchWeekday = DateTime.fromMillis(currentLunchTimeStamp).weekday - 1;
            const { days = [] } = lunch.week;

            return [ 0, 1, 2, 3, 4, 5, 6 ].map(weekday => ({
                date: date.plus({ days: weekday }),
                items: days[weekday] ?? [],
                activeLunch: weekday === currentLunchWeekday,
            }));
        },
    },
};
</script>
<style scoped>
.lunch-list {
  display: flex;
  flex-flow: column wrap;
  max-width: 760px;
  width: 100%;
}
.lunch-list .lunch-list-item {
  padding: 1.5rem;
  border: 1px solid var(--color-base-grey-300);
  border-radius: 0.25rem;
}
.lunch-list .lunch-list-item:not(:last-child) {
  margin-bottom: 0.5rem;
}
.lunch-list .lunch-list-item.today {
  position: relative;
}
.lunch-list .lunch-list-item.today::before {
  content: "";
  width: 0.375rem;
  height: 100%;
  left: 0;
  top: 0;
  border-radius: 0.25rem 0 0 0.25rem;
  background-color: var(--color-primary-500);
  position: absolute;
}
.lunch-list .lunch-list-item .item {
  min-height: 2.375rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 1rem;
}
.lunch-list .lunch-list-item .item:nth-child(2n) {
  background: var(--color-secondary-500);
}
.lunch-list .h4 {
  color: var(--color-primary-500);
}
</style>
